import React from "react"
import { RiLogoutBoxRLine } from "react-icons/ri"

/**
 * O ID de cada opção é relevante para filtragem de acordo com as permissões concedidas ao grupo do usuário
 * E são sensitive-case
 */

export const avatarMenuOptions = [
	{
		id: 'global',
		path: "/logout",
		icon: (<RiLogoutBoxRLine size={16} color="#222222" />),
		label: "Sair",
		labelComponent: null,
	}
]

export const headerMenuOptions = [
	{
		id: 'Dashboard',
		path: "/dashboard",
		label: "Dashboard",
		subMenu: null
	},
	{
		id: 'Team',
		path: "/team",
		icon: null,
		label: "Equipes",
	},
	{
		id: 'GruposDeUsuario;Usuarios',
		path: "/acessos",
		label: "Usuários",
		subMenu: null
	},
	{
		id: 'Configuracao',
		path: "/configuracoes",
		label: "Configurações",
		subMenu: null
	},
]